import { useMatomo } from '@datapunt/matomo-tracker-react';
import Typography from '@material-ui/core/Typography';
import { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';

import { getFileStatus } from '../../../shared/helpers/upload-helpers';
import AppSummary from '../../components/AppSummary/app-summary';
import { applicationSaveFile } from '../../redux/scholarship.actions';
import { EnumAppDocType, EnumFileStatus, MAppEssay, MApplication, MAppTranscript } from '../../redux/scholarship.models';
import { selectApplication } from '../../redux/scholarship.selectors';
import { ApplicationFormContainer } from '../ApplicationsForm/applications-form.styles';

const ApplicationComplete = ({
  dispatchSaveFile
}: {
  dispatchSaveFile: (saveFile: MAppEssay | MAppTranscript | Record<string, unknown>, section: EnumAppDocType) => void;
}) => {
  const { trackPageView } = useMatomo();
  const [scanningEssay, setScanningEssay] = useState<boolean>(false);
  const [scanningTranscript, setScanningTranscript] = useState<boolean>(false);
  let currentApp: MApplication = useSelector(selectApplication);

  const intervalObj: Record<string, { interval: NodeJS.Timeout | number }> = {
    essay: {
      interval: 0
    },
    transcript: {
      interval: 0
    }
  };

  const handleFileStatus = async (fileType: EnumAppDocType) => {
    const fileUpdate = await getFileStatus(currentApp.id, EnumAppDocType[fileType.toUpperCase()]);
    if (
      fileUpdate &&
      (fileUpdate.docStatus === EnumFileStatus.RECEIVED ||
        fileUpdate.docStatus === EnumFileStatus.FAILED ||
        fileUpdate.docStatus === EnumFileStatus.MALICIOUS)
    ) {
      dispatchSaveFile(fileUpdate, fileType);
      if (fileType === EnumAppDocType.ESSAY) {
        setScanningEssay(false);
      }

      if (fileType === EnumAppDocType.TRANSCRIPT) {
        setScanningTranscript(false);
      }
      clearInterval(intervalObj[fileType].interval);
    }
  };

  const handleSetInterval = (triggerObj: MAppEssay | MAppTranscript, fileType: EnumAppDocType): (() => void) | undefined => {
    if (triggerObj.filePath && (triggerObj.docStatus === EnumFileStatus.PENDING || triggerObj.docStatus === EnumFileStatus.DELETED)) {
      intervalObj[fileType].interval = setInterval(() => handleFileStatus(fileType), 5000);
      if (fileType === EnumAppDocType.ESSAY) {
        setScanningEssay(true);
      }

      if (fileType === EnumAppDocType.TRANSCRIPT) {
        setScanningTranscript(true);
      }

      return () => {
        clearInterval(intervalObj[fileType].interval);
      };
    }
  };

  useEffect(() => {
    if (currentApp) {
      handleSetInterval(currentApp.essay, EnumAppDocType.ESSAY);
    }
  }, [currentApp?.essay]);

  useEffect(() => {
    if (currentApp) {
      handleSetInterval(currentApp.transcript, EnumAppDocType.TRANSCRIPT);
    }
  }, [currentApp?.transcript]);

  // Track page view
  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <ApplicationFormContainer>
      <Typography variant="h4" gutterBottom>
        Submitted Application
      </Typography>
      <Typography variant="body1" gutterBottom>
        Further edits cannot be made to this application.
      </Typography>
      <AppSummary scanningTranscript={scanningTranscript} scanningEssay={scanningEssay} />
    </ApplicationFormContainer>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  dispatchSaveFile: (saveFile: MAppEssay | MAppTranscript | Record<string, unknown>, section: EnumAppDocType): void => {
    dispatch(applicationSaveFile(saveFile, section));
  }
});

export default connect(null, mapDispatchToProps)(ApplicationComplete);
